import { FC, useCallback, useContext } from 'react';

import { AsyncSearch } from 'components';
import { Customer } from 'types';

import { useCustomerAPI } from 'hooks/use-customer-api';
import { RedeliveryContext } from '../redelivery-context';

const RedeliveryCustomer: FC = () => {
  const { searchCustomers } = useCustomerAPI();
  const { customer, setCustomer, redeliveryNumberRef, units } = useContext(RedeliveryContext);

  const handleSelect = useCallback(
    (option?: Customer) => {
      setCustomer(option);
      redeliveryNumberRef.current?.revalidate();
    },
    [setCustomer, redeliveryNumberRef]
  );

  return (
    <AsyncSearch<Customer>
      data-cy="redelivery-account-search"
      disabled={!!units.size}
      formatValue={option => option?.name ?? ''}
      handleSelect={handleSelect}
      label="ACCOUNT"
      required
      search={searchCustomers}
      value={customer}
    />
  );
};

export default RedeliveryCustomer;
